module.exports = "/static/media/sms_enrollment_brand.ab14d8ae.png";